// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentOutlinedSvg from "@fishx/icons-svg/es/asn/ExperimentOutlined";
import FishxIcon from '../components/FishxIcon';

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentOutlinedSvg
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
export default React.forwardRef(ExperimentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExperimentOutlined.js
// module id = 2639
// module chunks = 0